module.exports = __webpack_public_path__ + "static/media/riskMetrics.f45d7f0c.jpg";